import { trigger, AUTO_STYLE, state, style, transition, animate, group } from '@angular/animations';

export const SlideInOutAnimation = [
  trigger('slideInOut', [
    state(
      'in',
      style({
        'max-height': '500px',
        opacity: '1',
        visibility: 'visible',
      })
    ),
    state(
      'out',
      style({
        'max-height': '0px',
        opacity: '0',
        visibility: 'hidden',
      })
    ),
    transition('in => out', [
      group([
        animate(
          '200ms ease-in-out',
          style({
            opacity: '0',
          })
        ),
        animate(
          '400ms ease-in-out',
          style({
            'max-height': '0px',
          })
        ),
        animate(
          '400ms ease-in-out',
          style({
            visibility: 'hidden',
          })
        ),
      ]),
    ]),
    transition('out => in', [
      group([
        animate(
          '1ms ease-in-out',
          style({
            visibility: 'visible',
          })
        ),
        animate(
          '400ms ease-in-out',
          style({
            'max-height': '500px',
          })
        ),
        animate(
          '400ms ease-in-out',
          style({
            opacity: '1',
          })
        ),
      ]),
    ]),
  ]),
];

export const mainMenu = [
  trigger('mobileMenuTop', [
    state(
      'no-block, void',
      style({
        overflow: 'hidden',
        height: '0px',
      })
    ),
    state(
      'yes-block',
      style({
        height: AUTO_STYLE,
      })
    ),
    transition('no-block <=> yes-block', [animate('400ms ease-in-out')]),
  ]),
  trigger('slideInOut', [
    state(
      'in',
      style({
        transform: 'translate3d(0, 0, 0)',
      })
    ),
    state(
      'out',
      style({
        transform: 'translate3d(100%, 0, 0)',
      })
    ),
    transition('in => out', animate('400ms ease-in-out')),
    transition('out => in', animate('400ms ease-in-out')),
  ]),
  trigger('slideOnOff', [
    state(
      'on',
      style({
        transform: 'translate3d(0, 0, 0)',
      })
    ),
    state(
      'off',
      style({
        transform: 'translate3d(100%, 0, 0)',
      })
    ),
    transition('on => off', animate('400ms ease-in-out')),
    transition('off => on', animate('400ms ease-in-out')),
  ]),
  trigger('fadeInOutTranslate', [
    transition(':enter', [style({ opacity: 0 }), animate('400ms ease-in-out', style({ opacity: 1 }))]),
    transition(':leave', [style({ transform: 'translate(0)' }), animate('400ms ease-in-out', style({ opacity: 0 }))]),
  ]),
  trigger('compactExpandedText', [
    state(
      'compact',
      style({
        visibility: 'hidden',
        opacity: '0',
        'max-width': '0px',
      })
    ),
    state(
      'expanded',
      style({
        visibility: 'visible',
        opacity: '1',
        'max-width': 'initial',
      })
    ),
    transition('compact => expanded', [
      animate(
        '0.3s ease-in-out',
        style({
          visibility: 'visible',
          opacity: '1',
          'max-width': 'initial',
        })
      ),
    ]),
    transition('expanded => compact', [
      animate(
        '0.2s ease-in-out',
        style({
          visibility: 'hidden',
          opacity: '0',
          'max-width': '0px',
        })
      ),
    ]),
  ]),
  trigger('compactExpandedIcon', [
    state(
      'compact',
      style({
        'margin-right': '0px',
        'text-align': 'center',
        'margin-left': '10px',
      })
    ),
    state(
      'expanded',
      style({
        'margin-right': '10px',
        'text-align': 'left',
        'margin-left': '0px',
      })
    ),
    transition('compact => expanded', [
      animate(
        '0.3s ease-in-out',
        style({
          'margin-right': '10px',
          'text-align': 'left',
          'margin-left': '0px',
        })
      ),
    ]),
    transition('expanded => compact', [
      animate(
        '0.3s ease-in-out',
        style({
          'margin-right': '0px',
          'text-align': 'center',
          'margin-left': '10px',
        })
      ),
    ]),
  ]),
];
